// extracted by mini-css-extract-plugin
module.exports = {"root":"PaginableContainer_root__B9Tf0","paginable":"PaginableContainer_paginable__5KYvg","parentRoot":"PaginableContainer_parentRoot__0P_Uy"};